'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PlanCode$() {
  this.c9f = null;
  this.c9g = false;
  this.c9d = null;
  this.c9e = false;
  this.c9b = null;
  this.YX = null;
  this.c9c = null;
  $n_Lpresto_types$PlanCode$ = this;
  this.c9b = ($m_Lpresto_types$PlanCode$(), "default");
  this.YX = ($m_Lpresto_types$PlanCode$(), "freemium_2fa");
  this.c9c = ($m_Lpresto_types$PlanCode$(), "presto_sign");
}
export { $c_Lpresto_types$PlanCode$ as $c_Lpresto_types$PlanCode$ };
$p = $c_Lpresto_types$PlanCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PlanCode$;
/** @constructor */
function $h_Lpresto_types$PlanCode$() {
}
export { $h_Lpresto_types$PlanCode$ as $h_Lpresto_types$PlanCode$ };
$h_Lpresto_types$PlanCode$.prototype = $p;
$p.cJc = (function() {
  if ((!this.c9g)) {
    this.c9f = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c9g = true;
  }
  return this.c9f;
});
$p.ae1 = (function() {
  if ((!this.c9e)) {
    this.c9d = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c9e = true;
  }
  return this.c9d;
});
var $d_Lpresto_types$PlanCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PlanCode$, "presto.types$PlanCode$", ({
  a0U: 1,
  D: 1
}));
export { $d_Lpresto_types$PlanCode$ as $d_Lpresto_types$PlanCode$ };
var $n_Lpresto_types$PlanCode$;
function $m_Lpresto_types$PlanCode$() {
  if ((!$n_Lpresto_types$PlanCode$)) {
    $n_Lpresto_types$PlanCode$ = new $c_Lpresto_types$PlanCode$();
  }
  return $n_Lpresto_types$PlanCode$;
}
export { $m_Lpresto_types$PlanCode$ as $m_Lpresto_types$PlanCode$ };
//# sourceMappingURL=presto.types$-Plan-Code$.js.map
